import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { Bau365DataAccessFairConfigModule } from './bau365-data-access-fair-config.module';

import { DataAccessEventsService } from '../services/events/data-access-events.service';
import { DataAccessExhibitorService } from '../services/exhibitors/data-access-exhibitors.service';
import { DataAccessFairsService } from '../services/fairs/data-access-fairs.service';
import { DataAccessPostsService } from '../services/posts/data-access-posts.service';
import { DataAccessProductsService } from '../services/products/data-access-products.service';
import { DataAccessProfessionsService } from '../services/professions/data-access-professions.service';
import { DataAccessEventsEffects } from '../states/events/entity/data-access-events.effects';
import { DataAccessEventsFacade } from '../states/events/entity/data-access-events.facade';
import * as fromFairDataEvents from '../states/events/entity/data-access-events.reducer';
import { DataAccessEventsPageEffects } from '../states/events/page/data-access-events.page.effects';
import { DataAccessEventsPageFacade } from '../states/events/page/data-access-events.page.facade';
import { DataAccessExhibitorsEffects } from '../states/exhibitors/entity/data-access-exhibitors.effects';
import { DataAccessExhibitorsFacade } from '../states/exhibitors/entity/data-access-exhibitors.facade';
import * as fromFairDataExhibitors from '../states/exhibitors/entity/data-access-exhibitors.reducer';
import { DataAccessExhibitorsPageEffects } from '../states/exhibitors/page/data-access-exhibitors.page.effects';
import { DataAccessExhibitorsPageFacade } from '../states/exhibitors/page/data-access-exhibitors.page.facade';
import { DataAccessFairsEffects } from '../states/fairs/entity/data-access-fairs.effects';
import { DataAccessFairsFacade } from '../states/fairs/entity/data-access-fairs.facade';
import * as fromFairDataFairs from '../states/fairs/entity/data-access-fairs.reducer';
import { DataAccessPostsEffects } from '../states/posts/entity/data-access-posts.effects';
import { DataAccessPostsFacade } from '../states/posts/entity/data-access-posts.facade';
import * as fromFairDataPosts from '../states/posts/entity/data-access-posts.reducer';
import { DataAccessPostsPageEffects } from '../states/posts/page/data-access-posts.page.effects';
import { DataAccessPostsPageFacade } from '../states/posts/page/data-access-posts.page.facade';
import { DataAccessProductsEffects } from '../states/products/entity/data-access-products.effects';
import { DataAccessProductsFacade } from '../states/products/entity/data-access-products.facade';
import * as fromFairDataProducts from '../states/products/entity/data-access-products.reducer';
import { DataAccessProductsPageEffects } from '../states/products/page/data-access-products.page.effects';
import { DataAccessProductsPageFacade } from '../states/products/page/data-access-products.page.facade';
import { DataAccessProfessionsEffects } from '../states/professions/entity/data-access-professions.effects';
import { DataAccessProfessionsFacade } from '../states/professions/entity/data-access-professions.facade';
import * as fromFairDataProfessions from '../states/professions/entity/data-access-professions.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromFairDataEvents.DATA_ACCESS_EVENTS_FEATURE_KEY, fromFairDataEvents.eventsReducer),
    StoreModule.forFeature(
      fromFairDataExhibitors.DATA_ACCESS_EXHIBITORS_FEATURE_KEY,
      fromFairDataExhibitors.exhibitorsReducer
    ),
    StoreModule.forFeature(fromFairDataFairs.DATA_ACCESS_FAIRS_FEATURE_KEY, fromFairDataFairs.fairsReducer),
    StoreModule.forFeature(fromFairDataPosts.DATA_ACCESS_POSTS_FEATURE_KEY, fromFairDataPosts.postsReducer),
    StoreModule.forFeature(fromFairDataProducts.DATA_ACCESS_PRODUCTS_FEATURE_KEY, fromFairDataProducts.productsReducer),
    StoreModule.forFeature(
      fromFairDataProfessions.DATA_ACCESS_PROFESSIONS_FEATURE_KEY,
      fromFairDataProfessions.professionsReducer
    ),
    EffectsModule.forFeature([
      DataAccessEventsEffects,
      DataAccessExhibitorsEffects,
      DataAccessFairsEffects,
      DataAccessPostsEffects,
      DataAccessProductsEffects,
      DataAccessProfessionsEffects,
    ]),
    EffectsModule.forFeature([DataAccessProductsPageEffects, DataAccessProductsPageFacade]),
    EffectsModule.forFeature([DataAccessPostsPageEffects]),
    EffectsModule.forFeature([DataAccessExhibitorsPageEffects]),
    EffectsModule.forFeature([DataAccessEventsPageEffects]),
    Bau365DataAccessFairConfigModule,
  ],
  providers: [
    DataAccessEventsService,
    DataAccessExhibitorService,
    DataAccessFairsService,
    DataAccessPostsService,
    DataAccessProductsService,
    DataAccessProfessionsService,
    DataAccessEventsFacade,
    DataAccessExhibitorsFacade,
    DataAccessFairsFacade,
    DataAccessPostsFacade,
    DataAccessProductsFacade,
    DataAccessProfessionsFacade,
    DataAccessPostsPageFacade,
    DataAccessExhibitorsPageFacade,
    DataAccessEventsPageFacade,
  ],
})
export class Bau365DataAccessFairDataModule {}
